import React, { } from 'react'
import { Sankey } from '@ant-design/plots'
import ChartHeader from './ChartHeader'

const fakeData = [
  { source: 'First time opening', target: 'Homepage UV', value: 160 },
  { source: 'Result page', target: 'Homepage UV', value: 40 },
  { source: 'Verification page', target: 'Homepage UV', value: 10 },
  { source: 'My page', target: 'Homepage UV', value: 10 },
  { source: 'Friends', target: 'Homepage UV', value: 8 },
  { source: 'Other sources', target: 'Homepage UV', value: 27 },
  { source: 'Homepage UV', target: 'Financial Management', value: 30 },
  { source: 'Homepage UV', target: 'Scan', value: 40 },
  { source: 'Homepage UV', target: 'Service', value: 35 },
  { source: 'Homepage UV', target: 'Ant Forest', value: 25 },
  { source: 'Homepage UV', target: 'Bounce', value: 10 },
  { source: 'Homepage UV', target: 'Borrow', value: 30 },
  { source: 'Homepage UV', target: 'Huabei', value: 40 },
  { source: 'Homepage UV', target: 'Other flow direction', value: 45 }
]

function SankeyChart (props) {
  const { data, settingMode, useFakeData } = props
  const { content } = data || {}

  const config = {
    data: settingMode || useFakeData ? fakeData : content?.data,
    sourceField: 'source',
    targetField: 'target',
    weightField: 'value',
    edgeStyle: {
      fill: '#ccc',
      fillOpacity: 0.4
    }
  }

  return (
    <>
      <ChartHeader {...props} />
      <Sankey {...config} style={{ marginTop: '16px' }} height={600}/>
    </>
  )
}

export default SankeyChart
